<div class="expand" [ngClass]="{ 'expand--collapsed': !expanded }">
  <div
    class="expand__content"
    [@collapse]="{
      value: expanded ? 'expanded' : 'collapsed'
    }"
    (cdkObserveContent)="handleToggleVisibility()"
  >
    <ng-content select="[content]"></ng-content>
    <div class="expand__content-blur"></div>
  </div>
</div>
<span
  *ngIf="showToggle"
  class="text-small action-color pointer semi-bold mb-3 mt-3"
  (click)="toggle()"
>
  {{ expanded ? "Read Less" : "Read More" }}
</span>
